import { useState, useEffect } from 'react';

function useNetworkStatus() {
    const [isOnline, setIsOnline] = useState(true);

    const urlsToCheck = ['https://www.it4i.cz/favicon.ico', 'https://www.google.com/favicon.ico'];

    useEffect(() => {
        let intervalId;

        const checkNetworkStatus = async () => {
            if (navigator.onLine) {
                try {
                    let online = true;

                    try {
                        const response = await fetch(urlsToCheck[0], {
                            method: 'HEAD',
                            mode: 'no-cors',
                            cache: 'no-cache',
                        });

                        if (!response) {
                            const fallbackResponse = await fetch(urlsToCheck[1], {
                                method: 'HEAD',
                                mode: 'no-cors',
                                cache: 'no-cache',
                            });
                            if (!fallbackResponse) {
                                online = false;
                            }
                        }
                    } catch (error) {
                        try {
                            const fallbackResponse = await fetch(urlsToCheck[1], {
                                method: 'HEAD',
                                mode: 'no-cors',
                                cache: 'no-cache',
                            });
                            if (!fallbackResponse) {
                                online = false;
                            }
                        } catch (error) {
                            online = false;
                        }
                    }

                    setIsOnline(online);
                } catch (error) {
                    setIsOnline(false);
                }
            } else {
                setIsOnline(false);
            }
        };

        checkNetworkStatus();
        intervalId = setInterval(checkNetworkStatus, 5000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    return isOnline;
}

export default useNetworkStatus;
